import { authService } from "../services/auth.service";
import { accessAuthState } from '../states/auth.state'

declare global {
    interface Window {
        FB: any;
        fbAsyncInit: () => void;
    }
}

const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;

export function initFacebookSdk() {
    return new Promise(resolve => {
        // wait for facebook sdk to initialize before starting the react app
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: facebookAppId,
                cookie: true,
                xfbml: true,
                version: 'v8.0'
            });

            resolve(1)

            // auto authenticate with the api if already logged in with facebook
            // window.FB.getLoginStatus((res: any) => {
            //     console.log('getLoginStatus=', res.authResponse);
            //     if (res.authResponse) {
            //         accessAuthState().loginFB(res.authResponse.accessToken)
            //         resolve(1)
            //     } else {
            //         resolve(1);
            //     }
            // });
        };

        // load facebook sdk script
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s) as HTMLImageElement;
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs!.parentNode!.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    });
}